// Text and infobox share an operation history. Other metadata is never restored
// from these snapshots, so undo cannot overwrite unrelated title/category edits.
export const editorSnapshot = edit => ({wikitext:edit.wikitext||'',infobox:edit.infobox||''});
export function recordEditorChange(history, edit, patch) {
 const before=editorSnapshot(edit),after=editorSnapshot({...edit,...patch});
 if(before.wikitext===after.wikitext&&before.infobox===after.infobox)return null;
 history.past.push(before);
 if(history.past.length>80)history.past.shift();
 history.future=[];
 return {...edit,...after};
}
export function restoreEditorChange(history, edit, redo=false) {
 const from=history[redo?'future':'past'],to=history[redo?'past':'future'];
 if(!from.length)return null;
 const next=from.pop();to.push(editorSnapshot(edit));
 return {...edit,...next};
}
